// extracted by mini-css-extract-plugin
module.exports = {"score":"Score_score__QI3yi","text":"Score_text__pix2d"};